export const dateParser = (date) => {
  let a;
  if (date && date.includes("T")) {
    a = date.split("T")[0];
  } else {
    a = date;
  }
  //const b = date.split("T")[1];
  //const c = b.split(".")[0];
  const [year, month, day] = a.split("-"); // Splits into ["2025", "03", "27"]
  //return `${day}-${month}-${year}`; // Returns "27-03-2025"
  return `${year}-${month}-${day}`; // Returns "2025-03-27"
  // return a;
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Note: Months are zero-based (0-11)
  const currentDay = currentDate.getDate();

  return `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-${currentDay.toString().padStart(2, "0")}`;
};

export const getCurrentDateWithOutHyphen = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Note: Months are zero-based (0-11)
  const currentDay = currentDate.getDate();

  return `${currentDay.toString().padStart(2, "0")}${currentMonth
    .toString()
    .padStart(2, "0")}${currentYear}`;
};

export const dateChangerFunc = (date) => {
  const [year, month, day] = date.split("-"); // Correct: array destructuring
  return `${day}-${month}-${year}`;
};
